<button
  *ngIf="isActive"
  (click)="manualClickTrigger()"
  class="btn-default p-relative"
>
  <div class="fork-wrapper">
    <div class="fork-info">
      <mat-icon svgIcon="forklift-mini"></mat-icon>
    </div>
    <ng-container *ngIf="isSettingsOk; else noconnect">
      <ng-container *ngIf="isOnline; else nolink">
        <ng-container [ngSwitch]="displayState">
          <div
            *ngSwitchCase="'idle'"
            class="drop-idle"
          >
            IDLE
          </div>
          <div *ngSwitchCase="'pick-scan'" class="drop-pick">
            <mat-icon>arrow_drop_up</mat-icon>
          </div>
          <div *ngSwitchCase="'loading'" class="drop-spin">
            <mat-spinner class="white" [diameter]="15"></mat-spinner>
          </div>
          <div *ngSwitchCase="'drop-forward'" class="drop-forward">
            <mat-icon>arrow_right</mat-icon>
          </div>
          <div *ngSwitchCase="'drop-scan'" class="drop-drop">
            <mat-icon>arrow_drop_down</mat-icon>
          </div>
          <!-- <div *ngSwitchCase="'drop'" class="drop-nb">{{ dropNb }}</div> -->
        </ng-container>
        <mat-icon class="fs wb" *ngIf="warning">warning</mat-icon>
        <span *ngIf="dropNb" class="select-nb">{{ dropNb }}</span>
      </ng-container>
    </ng-container>
  </div>

  <ng-template #noconnect>
    <div class="drop-noconnect">
      <mat-icon>power_settings_new</mat-icon>
    </div>
  </ng-template>

  <ng-template #nolink>
    <div class="drop-error">
      <mat-icon>link_off</mat-icon>
    </div>
  </ng-template>

  <span
    [ngClass]="{
      ok: health && !health.tooMuchLatency && health.status === 'connected'
    }"
    class="indicator"
  ></span>
</button>
